import React from 'react';
import { Box, makeStyles, Theme, Grid } from '@material-ui/core';

import { AccountUsers } from './components/AccountUsers';
// import { ProfileSideBar } from '../../../components/ProfileSideBar';
import { TopBar } from '../../../components/TopBar';
import { SideBar } from '../../../components/SideBar';

export const AccountUsersPage = () => {
  const classes = useStyles();
  const user: any = localStorage.getItem('formFlash');
  const loggedInUser = JSON.parse(user);

  return (
    loggedInUser && <Box className={classes.main} display="flex" flexDirection="column" p={4}>
      <Box mb={4}>
        <TopBar />
      </Box>
      <Grid container>
        <Grid item xs={12} sm={2} md={2}>
          <SideBar />
        </Grid>
        <Grid item xs={12} sm={10} md={10}>
          <AccountUsers />
        </Grid>
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    [theme.breakpoints.down('xs')]: {
      padding: '1rem'
    },
    backgroundColor: theme.background.main,
    minHeight: '100vh'
  },
  contentContainer: {
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  }
}));
